export default function /* @ngInject */ stripeExpirationYears() {
    let years = [];
    const EXPIRY_YEARS_FUTURE = 20;
    for (let y = 0; y <= EXPIRY_YEARS_FUTURE; y++) {
        let year = (new Date()).getFullYear() + y;
        years.push({val: year, title: year});
    }
    return years;
}



// WEBPACK FOOTER //
// ./stripe/services/stripe-expiration-years.js